import type { SizeOptionWithEdd } from '../domain/models/CustomizationOptions';
import { isTDD } from '@/features/pdp/utils/eddFormatting';
import { isNddSize } from './sizeSection.utils';

export type SizeEddDisplayVariant = 'none' | 'tomorrow' | 'today' | 'standard';

export interface SizeEddDisplay {
  variant: SizeEddDisplayVariant;
  label: string;
}

export function getSizeEddDisplay(
  size: SizeOptionWithEdd,
  nddAvailableSizes: string[] | null
): SizeEddDisplay {
  if (!size.edd && !size.eddFullDate) {
    return { variant: 'none', label: '' };
  }

  if (size.eddFullDate && isTDD(size.eddFullDate)) {
    return { variant: 'today', label: size.edd ?? 'Today Evening' };
  }

  if (isNddSize(size, nddAvailableSizes)) {
    return { variant: 'tomorrow', label: 'Tomorrow' };
  }

  return { variant: 'standard', label: size.edd ?? '' };
}

export function shouldShowSizeSheetEddColumn(
  hasPincode: boolean,
  sizes: SizeOptionWithEdd[]
): boolean {
  return hasPincode && sizes.some((size) => Boolean(size.edd || size.eddFullDate));
}
